import apiClient from 'api';
const authServerBaseUrl = window.env.REACT_APP_SERVER_API_PATH;

export const login = async (email, password) => {
  return await apiClient.post(authServerBaseUrl, `/auth/login`, {
    email: email,
    password: password
  });
};

export const mfaAuth = async (email, mfaAuthToken, mfaCode) => {
  return await apiClient.post(
    authServerBaseUrl,
    `/auth/multi_factor_authentication`,
    {
      email: email,
      mfaCode: mfaCode,
      mfaAuthToken: mfaAuthToken
    }
  );
};

export const cancelMfa = async (email, mfaAuthToken) => {
  try {
    await apiClient.put(
      authServerBaseUrl,
      `/auth/multi_factor_authentication`,
      {
        email: email,
        mfaAuthToken: mfaAuthToken
      }
    );
    // On success, return a message
    return { message: 'MFA request cancelled successfully' };
  } catch (error) {
    // If an error occurs, throw it
    throw error;
  }
};

export const logout = async () => {
  return await apiClient.post(authServerBaseUrl, `/auth/logout`);
};

export const verifyAccount = async (email, token, password) => {
  return await apiClient.post(authServerBaseUrl, `/auth/verify`, {
    email: email,
    token: token,
    password: password
  });
};

export const verifyTokenMatches = async (email, token) => {
  const encodedEmail = encodeURIComponent(email);
  return await apiClient.get(
    authServerBaseUrl,
    `/auth/verify_matching_token?email=${encodedEmail}&token=${token}`
  );
};

export const sendResetPasswordEmail = async email => {
  const encodedEmail = encodeURIComponent(email);
  return await apiClient.post(
    authServerBaseUrl,
    `/auth/forgot_password?email=${encodedEmail}`
  );
};

export const resetPassword = async (email, token, password) => {
  return await apiClient.post(authServerBaseUrl, `/auth/reset_password`, {
    email: email,
    token: token,
    password: password
  });
};
